<template>
  <div>
    <v-skeleton-loader
      v-if="loading"
      type="list-item-three-line,divider,list-item-three-line,divider,list-item"
    ></v-skeleton-loader>
    <v-list v-else>
      <v-radio-group v-model="form_id" :readonly="readonly">
        <div v-for="address in addresses" :key="address.id">
          <v-list-item>
            <v-list-item-action>
              <v-radio :value="address.id"></v-radio>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ address.rua }}, {{ address.numero }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ address.bairro }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ address.cidade }}, {{ address.uf }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
        </div>
        <v-list-item>
          <v-list-item-action>
            <v-radio :value="-1"></v-radio>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title> Outro </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-radio-group>
    </v-list>
    <v-dialog v-model="address_form_dialog" max-width="600">
      <AddressForm
        @close="address_form_dialog = false"
        title="Cadastrar Endereço"
      />
    </v-dialog>
  </div>
</template>

<script>
import { show as showClient } from "@/services/clients";
import AddressForm from "@/components/forms/AddressForm";

export default {
  name: "address-picker",
  components: { AddressForm },
  model: {
    prop: "address",
    event: "change",
  },
  props: {
    client_id: {
      type: Number,
      default: null,
    },
    address: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    addresses: [],
    form_id: null,
    form: {},
    address_form_dialog: false,
    loading: false,
    error: null,
  }),
  methods: {
    async getAddresses(client_id) {
      this.loading = true;
      try {
        const response = await showClient(client_id);
        this.addresses = [...response.enderecos];
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    changeForm(key, value) {
      this.$emit("change", {
        ...this.address,
        [key]: value,
      });
    },
    getDefaultForm() {
      return {
        cep: "13700-000",
        cidade: "Casa Branca",
        uf: "SP",
      };
    },
  },
  computed: {
    cep: {
      get() {
        return this.address.cep;
      },
      set(value) {
        this.changeForm("cep", value);
      },
    },
    uf: {
      get() {
        return this.address.uf;
      },
      set(value) {
        this.changeForm("uf", value);
      },
    },
    cidade: {
      get() {
        return this.address.cidade;
      },
      set(value) {
        this.changeForm("cidade", value);
      },
    },
    bairro: {
      get() {
        return this.address.bairro;
      },
      set(value) {
        this.changeForm("bairro", value);
      },
    },
    rua: {
      get() {
        return this.address.rua;
      },
      set(value) {
        this.changeForm("rua", value);
      },
    },
    numero: {
      get() {
        return this.address.numero;
      },
      set(value) {
        this.changeForm("numero", value);
      },
    },
    complemento: {
      get() {
        return this.address.complemento;
      },
      set(value) {
        this.changeForm("complemento", value);
      },
    },
  },
  watch: {
    client_id: function (value) {
      if (!value) return;

      this.getAddresses(value);
    },
    form_id: async function (value) {
      console.log(value);
      if (value !== -1) {
        this.$emit(
          "change",
          this.addresses.find((address) => address.id === value)
        );
      } else {
        this.$emit("change", this.getDefaultForm());
        await this.$nextTick();
        this.$emit("change", this.getDefaultForm());
      }
    },
  },
  created() {
    if (this.client_id) this.getAddresses(this.client_id);
  },
};
</script>